import React from 'react';
import { DgtPdOrderPicklistMovement } from '../models';

// Define the shape of the context state
interface MovementContextState {
  movements: DgtPdOrderPicklistMovement[];
  mutateMovements: (mvs : DgtPdOrderPicklistMovement[]) => void;
}

// Create the context with a default value
const MovementContext = React.createContext<MovementContextState | undefined>(undefined);

export default MovementContext;